import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-la-educacion',
  templateUrl: './la-educacion.component.html',
  styleUrls: ['./la-educacion.component.scss']
})
export class LaEducacionComponent implements OnInit {

  constructor(private titleService: Title) {
    this.titleService.setTitle("LA EDUCACIÓN  EXPERIMENTAL EN EL ALTIPLANO (1930-1950)");
  }

  ngOnInit(): void {
  }
  slides = [
    { img: "/assets/images/micrositio/micrositio4/ET03_MS07_EDU_img003a.jpg", autor: "JOSÉ ANTONIO ENCINAS", anno: "1886-1958" },
    { img: "/assets/images/micrositio/micrositio4/ET03_MS07_EDU_img003b.jpg", autor: "LOS MAESTROS DEL GRUPO ORKOPATA", anno: "" },
    { img: "/assets/images/micrositio/micrositio4/ET03_MS07_EDU_img003c.jpg", autor: "JULIÁN PALACIOS RÍOS ", anno: "1887-1976" },
    { img: "/assets/images/micrositio/micrositio4/ET03_MS07_EDU_img003d.jpg", autor: "MARÍA ASUNCIÓN GALINDO", anno: "1895-1951" },
    { img: "/assets/images/micrositio/micrositio4/ET03_MS07_EDU_img003e.jpg", autor: "JUAN FRANCISCO DEZA GALINDO Y ANSELMO MOLLEAPASA COELLO", anno: "" },
    { img: "/assets/images/micrositio/micrositio4/ET03_MS07_EDU_img003f.jpg", autor: "JOSÉ PORTUGAL CATACORA", anno: "1911-1998" },
  ];

  slides2 = [    
    { id: "http://hdl.handle.net/20.500.14428/79182", img: "/assets/images/micrositio/micrositio4/ET03_MS07_EDU_img006a.jpg", autor: "Rutsí: el pequeño alucinado", anno: "1974" },
    { id: "https://hdl.handle.net/20.500.14428/44121", img: "/assets/images/micrositio/micrositio4/ET03_MS07_EDU_img006b.jpg", autor: "10 charlas sobre folklore", anno: "1946" },
    { id: "https://hdl.handle.net/20.500.14428/40976", img: "/assets/images/micrositio/micrositio4/ET03_MS07_EDU_img006c.jpg", autor: "Mitos, leyendas y cuentos peruanos", anno: "1947" },
    { id: "http://hdl.handle.net/20.500.14428/79185", img: "/assets/images/micrositio/micrositio4/ET03_MS07_EDU_img006d.jpg", autor: "Apuntes para el folklore peruano", anno: "1943" },
    { id: "http://hdl.handle.net/20.500.14428/79181", img: "/assets/images/micrositio/micrositio4/ET03_MS07_EDU_img006e.jpg", autor: "Indianismo. Adoptado para texto en las escuelas de Bolivia", anno: "1947" },
    { id: "http://hdl.handle.net/20.500.14428/79180", img: "/assets/images/micrositio/micrositio4/ET03_MS07_EDU_img006f.jpg", autor: "Yachay-Huasi: libro de lectura para escuelas campesinas y normales rurales del Ecuador", anno: "1945" },
  ];

  slideConfigSimple = {
    "slidesToShow": 3, "slidesToScroll": 1, "responsive": [
      {
        'breakpoint': 800,
        'settings':
        {
          'slidesToShow': 1
        }
      }
    ]
  };



  slideConfig = {
    "slidesToShow": 5, "slidesToScroll": 1, "responsive": [
      {
        'breakpoint': 800,
        'settings':
        {
          'slidesToShow': 1
        }
      }
    ]
  };
}
